import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import Backend from "i18next-http-backend"

export const hasTranslation = (key: string): boolean => {
  return i18n.exists(key)
}

// Get initial language from URL parameter or default to Vietnamese
const getInitialLanguage = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const langParam = urlParams.get("lang")

  // Check if lang param exists and is supported
  if (langParam && ["en", "vi"].includes(langParam)) {
    return langParam
  }

  // Default to Vietnamese
  return "vi"
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),
    fallbackLng: "en",
    supportedLngs: ["en", "vi"],
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    ns: ["translation", "pricing", "testimonials", "landing"],
    defaultNS: "translation",
    react: {
      useSuspense: false,
    },
  })

export default i18n
